module.exports = __webpack_public_path__ + "img/s4.8e569357.png";